import { useStore } from "../../context/StoreContext";

export const AnnouncementBar = () => {
  const { settings } = useStore();
  const show = settings?.announcement_enabled && settings?.announcement;
  return (
    <div className="bg-navy text-white text-xs sm:text-sm" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center">
        <p className="font-medium tracking-wide text-center" data-testid="announcement-text">
          {show ? settings.announcement : "Wear Your Vacation Vibes!"}
        </p>
      </div>
    </div>
  );
};
